import { axios } from '~/common/utils/request'
const commonPath = 'rest/erp/logistics/v3/'

/**
 * 仓库列表
 * @param {Object} params
 */
export const getWarehouseList = params => axios({
  url: `${commonPath}warehouse/list`,
  method: 'post',
  data: params
})

/**
 * 仓库启用/禁用
 * @param {Object} params
 */
export const setWarehouse = params => axios({
  url: `${commonPath}warehouse`,
  method: 'put',
  data: params
})

/**
 * 仓库详情编辑
 * @param {Object} params
 */
export const editWarehouse = params => axios({
  url: `${commonPath}warehouse`,
  method: 'put',
  data: params
})

/**
 * 仓库详情
 * @param {String} id
 */
export const getWarehouseInfo = id => axios({
  url: `${commonPath}warehouse/detail/${id}`,
  method: 'get'
})

/**
 * 库区列表
 * @param {Object} params
 */
export const getSectionList = params => axios({
  url: `${commonPath}section/list`,
  method: 'post',
  data: params
})

/**
 * 类型
 * @param {Object} params
 */
export const getFunctionCategory = params => axios({
  url: `${commonPath}function_category/list`,
  method: 'post',
  data: params
})

/**
 * 库区详情
 * @param {String} id
 */
export const getSectionInfo = id => axios({
  url: `${commonPath}section/detail/${id}`,
  method: 'get'
})

/**
 * 库区编辑
 * @param {String} id
 */
export const editSection = params => axios({
  url: `${commonPath}section`,
  method: 'put',
  data: params
})

/**
 * 库位列表
 * @param {Object} params
 */
export const getLotList = params => axios({
  url: `${commonPath}lot/list`,
  method: 'post',
  data: params
})

// 库位导出
export const exportLot = params => axios({
  url: `${commonPath}lot/export`,
  responseType: "blob",
  method: 'post',
  data: params
})

/**
 * 库位启用/禁用
 * @param {Object} params
 */
export const setLot = params => axios({
  url: `${commonPath}lot`,
  method: 'put',
  data: params
})

/**
 * 库位详情
 * @param {String} id
 */
export const getLotInfo = id => axios({
  url: `${commonPath}lot/detail/${id}`,
  method: 'get'
})

/**
 * 库位编辑
 * @param {String} id
 */
export const editLot = params => axios({
  url: `${commonPath}lot`,
  method: 'put',
  data: params
})

// 库位-跟踪号
export const getLotTrackingList = params => axios({
  url: `${commonPath}lot_tracking/list`,
  method: 'post',
  data: params
})

// 创建仓库
export const warehouseAdd = params => axios({
  url: `${commonPath}warehouse`,
  method: 'post',
  data: params
})

// 创建库区
export const sectionAdd = params => axios({
  url: `${commonPath}section`,
  method: 'post',
  data: params
})

// 创建库位
export const lotAdd = params => axios({
  url: `${commonPath}lot`,
  method: 'post',
  data: params
})

// 仓库类型
export const getWarehouseType = () => axios({
  url: `${commonPath}warehouse/type/list`,
  method: 'get'
})

// 库区类别
export const getSectionType = () => axios({
  url: `${commonPath}section/type/list`,
  method: 'get'
})

// 库位类型
export const getLotType = () => axios({
  url: `${commonPath}lot/type/list`,
  method: 'get'
})

// 获取佣金账户（账户域后台）
export const getEmployeeAccount = params => axios({
  url: `rest/erp/account/v3/employee_account/select`,
  method: 'post',
  data: params
})

// 获取佣金账户下交易员
export const getAccountShopMember = params => axios({
  url: `${commonPath}business/shop_member/all`,
  method: 'post',
  data: params
})

// 获取交易员所属主体公司
export const getMemberCompany = shopId => axios({
  url: `rest/store/account/v3/account/company_account/shop/${shopId}`,
  method: 'patch'
})
